<ng-template #portCard let-port>
  <div class="odb-cell" [class.dimmed]="dimmed(port)">
    <button
      type="button"
      class="odb-port"
      [ngClass]="{
        free: port.free,
        selected: isSelected(port),
        pickable: pickingOnu && port.free
      }"
      [title]="port.free ? 'Puerto vacío' : port.name || port.sn || ''"
      (click)="select(port)"
    >
      <span class="odb-port-no">
        @if (port.unassigned) {
        <i class="pi pi-exclamation-triangle" title="La ONU no tiene puerto asignado"></i>
        } {{ portLabel(port) }}
      </span>
      @if (port.free) {
      <span class="odb-port-icons"><i class="pi pi-circle" style="color: #94a3b8"></i></span>
      <span class="odb-signal">Vacío</span>
      } @else {
      <span class="odb-port-icons">
        <i
          class="pi"
          [ngClass]="statusMeta(port).icon"
          [style.color]="statusMeta(port).color"
          [title]="statusMeta(port).label"
        ></i>
        <span class="odb-bars" [title]="signalMeta(port).label">
          @for (b of [1, 2, 3, 4]; track b) {
          <span
            [style.height.px]="2 + b * 2"
            [style.background]="b <= bars(port) ? signalMeta(port).color : '#cbd5e1'"
          ></span>
          }
        </span>
      </span>
      <span class="odb-signal">
        @if (band.rx1310) {
        <span class="odb-rx"><span>1310</span>{{ rx(port, 'rx1310') }}</span>
        } @if (band.rx1490) {
        <span class="odb-rx"><span>1490</span>{{ rx(port, 'rx1490') }}</span>
        }
      </span>
      @if (!card) {
      <span class="odb-band">
        @for (s of bandSegments(port); track $index) {
        <span
          [style.left.%]="s.left"
          [style.width.%]="s.width"
          [style.background]="s.color"
          [title]="s.title"
        ></span>
        }
      </span>
      } }
    </button>
    @if (!pickingOnu && !card) {
    <button
      type="button"
      class="odb-menu-btn"
      title="Acciones"
      (click)="openMenu($event, port, menu)"
    >
      <i class="pi pi-ellipsis-v"></i>
    </button>
    }
  </div>
</ng-template>

<p-menu #menu [model]="menuItems" [popup]="true" appendTo="body" styleClass="odb-port-menu" />

<!-- anillos de uso, estado y señal: en el pie del modal y en la tarjeta -->
<ng-template #usageBlock let-u>
  <div class="odb-usage">
    <div class="odb-ring" [style.background]="u.statusGradient" title="Anillo exterior: estado">
      <div
        class="odb-ring-middle"
        [style.background]="u.signalGradient"
        title="Anillo interior: señal"
      >
        <div class="odb-ring-center"><span>{{ u.utilization }}%</span></div>
      </div>
    </div>
    <div class="odb-usage-groups">
      <div class="odb-usage-group">
        <span class="odb-usage-group-title">Estado</span>
        <div class="odb-usage-meta">
          @for (item of [ { k: 'online', l: 'Online', n: u.status.online }, { k: 'offline', l:
          'Offline', n: u.status.offline }, { k: 'unknown', l: 'Desconocido', n: u.status.unknown }
          ]; track item.k) {
          <button
            type="button"
            class="odb-usage-item"
            [ngClass]="item.k"
            [class.active]="isFilterOn('status', item.k)"
            (click)="toggleFilter('status', item.k)"
          >
            <span class="odb-usage-count">{{ item.n }}</span>
            <span class="odb-usage-label">{{ item.l }}</span>
          </button>
          }
          <span class="odb-usage-item free">
            <span class="odb-usage-count">{{ u.free ?? 'Desconocido' }}</span>
            <span class="odb-usage-label">Vacíos</span>
          </span>
        </div>
      </div>
      <div class="odb-usage-group">
        <span class="odb-usage-group-title">Señal</span>
        <div class="odb-usage-meta">
          @for (item of [ { k: 'good', l: 'Buena', n: u.signal.good }, { k: 'warning', l:
          'Advertencia', n: u.signal.warning }, { k: 'critical', l: 'Crítica', n: u.signal.critical
          }, { k: 'offline', l: 'Sin señal', n: u.signal.offline } ]; track item.k) {
          <button
            type="button"
            class="odb-usage-item"
            [ngClass]="item.k === 'offline' ? 'no-signal' : item.k"
            [class.active]="isFilterOn('signal', item.k)"
            (click)="toggleFilter('signal', item.k)"
          >
            <span class="odb-usage-count">{{ item.n }}</span>
            <span class="odb-usage-label">{{ item.l }}</span>
          </button>
          }
          <span class="odb-usage-item free">
            <span class="odb-usage-count">{{ u.free ?? 'Desconocido' }}</span>
            <span class="odb-usage-label">Vacíos</span>
          </span>
        </div>
      </div>
    </div>
  </div>
</ng-template>

@if (card) {
<!-- tarjeta del splitter (el popover de SmartOLT): resumen, puertos y "Ver splitter" -->
<div class="odb-card text-sm">
  @if (loading) {
  <div class="flex animate-pulse flex-col gap-3">
    <div class="h-[92px] rounded-lg bg-gray-100"></div>
    <div class="h-6 w-56 rounded bg-gray-100"></div>
    <div class="odb-card-grid">
      @for (i of [1, 2, 3, 4, 5, 6, 7, 8]; track i) {
      <div class="h-[74px] rounded-lg bg-gray-100"></div>
      }
    </div>
  </div>
  } @else if (error || !data) {
  <p class="rounded bg-red-50 p-3 text-red-700">{{ error || 'Splitter no disponible.' }}</p>
  } @else { @if (usage; as u) {
  <ng-container [ngTemplateOutlet]="usageBlock" [ngTemplateOutletContext]="{ $implicit: u }" />
  }
  <div class="odb-card-badges">
    <span class="odb-card-badge">1:{{ totalPorts || '∞' }} PLC splitter</span>
    @if (!totalPorts) {
    <span class="odb-card-badge warning">
      <i class="pi pi-exclamation-triangle"></i> Número de puertos sin definir
    </span>
    }
  </div>
  <div class="odb-card-scroll">
    @if (assigned.length) {
    <div class="odb-card-grid">
      @for (port of assigned; track $index) {
      <ng-container [ngTemplateOutlet]="portCard" [ngTemplateOutletContext]="{ $implicit: port }" />
      }
    </div>
    } @if (unassigned.length) {
    <p class="odb-unassigned-title">
      <i class="pi pi-exclamation-triangle"></i> ONUs adjuntas sin puerto asignado
    </p>
    <div class="odb-card-grid">
      @for (port of unassigned; track port.id) {
      <ng-container [ngTemplateOutlet]="portCard" [ngTemplateOutletContext]="{ $implicit: port }" />
      }
    </div>
    } @if (!assigned.length && !unassigned.length) {
    <p class="py-4 text-center text-gray-500">El splitter no tiene ONUs.</p>
    }
  </div>
  }
  <div class="odb-card-actions">
    <p-button
      label="Actualizar"
      icon="pi pi-refresh"
      size="small"
      severity="secondary"
      [outlined]="true"
      [loading]="refreshingAll"
      [disabled]="!data"
      title="Relee la señal de las ONUs desde la OLT"
      (onClick)="refreshAll()"
    />
    <p-button
      label="Ver splitter"
      icon="pi pi-arrow-right"
      iconPos="right"
      size="small"
      severity="success"
      (onClick)="viewSplitter.emit()"
    />
  </div>
</div>
} @else { @if (loading) {
<!-- esqueleto con la forma del modal: cabecera, dispositivo, panel y pie -->
<div class="flex animate-pulse flex-col gap-3">
  <div class="h-4 w-72 rounded bg-gray-200"></div>
  <div class="h-3 w-96 rounded bg-gray-100"></div>
  <div class="flex gap-3">
    <div class="h-4 w-20 rounded-full bg-gray-200"></div>
    <div class="h-4 w-20 rounded-full bg-gray-200"></div>
  </div>
  <div class="h-9 w-80 rounded bg-gray-100"></div>
  <div class="odb-layout">
    <div class="odb-shell compact">
      <div class="odb-grid">
        @for (i of [1, 2, 3, 4, 5, 6]; track i) {
        <div class="h-[86px] rounded-lg bg-gray-100"></div>
        }
      </div>
    </div>
    <div class="odb-panel flex flex-col gap-3">
      <div class="h-3 w-24 rounded bg-gray-200"></div>
      <div class="h-5 w-48 rounded bg-gray-200"></div>
      @for (i of [1, 2, 3]; track i) {
      <div class="h-16 rounded-md border border-gray-100 bg-gray-50"></div>
      } @for (i of [1, 2, 3, 4, 5, 6]; track i) {
      <div class="h-3 rounded bg-gray-100"></div>
      }
    </div>
  </div>
  <div class="odb-footer">
    <div class="odb-usage">
      <div class="h-[75px] w-[75px] rounded-full bg-gray-200"></div>
      <div class="flex flex-1 flex-col gap-3">
        <div class="h-6 w-2/3 rounded bg-gray-100"></div>
        <div class="h-6 w-3/4 rounded bg-gray-100"></div>
      </div>
    </div>
    <div class="flex w-32 flex-col gap-2">
      @for (i of [1, 2, 3]; track i) {
      <div class="h-8 rounded bg-gray-100"></div>
      }
    </div>
  </div>
</div>
} @else if (error || !data) {
<div class="flex flex-col items-start gap-2">
  <p class="rounded bg-red-50 p-3 text-red-700">{{ error || 'Splitter no disponible.' }}</p>
  <p-button label="Reintentar" icon="pi pi-refresh" (onClick)="load()" />
</div>
} @else {
<div class="odb-modal text-sm">
  <!-- cabecera -->
  <p class="odb-subtitle">ID {{ data.id }} • {{ summary }}</p>
  @if (healthLine) {
  <p class="odb-health">{{ healthLine }}</p>
  } @if (data.comment || data.note || data.external_id) {
  <p class="odb-health">
    @if (data.external_id) { ID externo: {{ data.external_id }} · } @if (data.comment) { {{
    data.comment }} · } {{ data.note }}
  </p>
  }

  <div class="odb-bands">
    @for (item of bands; track item.k) {
    <button type="button" [title]="item.t" (click)="toggleBand(item.k)">
      <span class="odb-switch" [class.on]="bandOn(item.k)"><span></span></span>
      {{ item.l }}
    </button>
    }
  </div>

  <!-- número de puertos -->
  <div class="odb-count">
    <span class="text-gray-600">1:</span>
    @if (!editingPorts) {
    <span class="odb-count-value">{{ totalPorts || '∞' }}</span>
    <span class="font-semibold text-gray-700">PLC splitter</span>
    <p-button
      label="Definir número de puertos"
      icon="pi pi-pencil"
      size="small"
      severity="secondary"
      [outlined]="true"
      (onClick)="startEditPorts()"
    />
    } @else {
    <select class="h-9 rounded border border-gray-300 px-2" [(ngModel)]="portChoice">
      <option value="" disabled>Nº de puertos</option>
      @for (n of portChoices; track n) {
      <option [value]="n">1:{{ n }}</option>
      }
      <option value="other">Otro</option>
    </select>
    @if (portChoice === 'other') {
    <input
      type="number"
      class="h-9 w-24 rounded border border-gray-300 px-2"
      min="1"
      max="256"
      [placeholder]="'' + (data.used_ports || 1)"
      [(ngModel)]="portOther"
    />
    }
    <p-button
      label="Guardar"
      icon="pi pi-save"
      size="small"
      [loading]="busy"
      [disabled]="portsToSave === null || !!portsError"
      (onClick)="savePorts()"
    />
    <p-button
      label="Cancelar"
      size="small"
      [text]="true"
      severity="secondary"
      (onClick)="editingPorts = false"
    />
    @if (portsError) {
    <small class="basis-full text-red-600">{{ portsError }}</small>
    } }
  </div>
  @if (!totalPorts && !editingPorts) {
  <p class="odb-warning">
    <i class="pi pi-exclamation-triangle"></i> Número de puertos sin definir
  </p>
  }

  <p class="odb-input">
    Entrada del splitter
    <i class="pi pi-circle" [style.color]="data.input_state ? '#1fb325' : '#94a3b8'"></i>
    <span>{{ data.input_state ? 'Vinculada' : 'Vacía' }}</span>
  </p>

  @if (pickingOnu) {
  <div class="odb-picking-bar">
    <span
      >Haga clic en un puerto vacío para colocar la ONU
      <strong>{{ pickingOnu.name || pickingOnu.sn }}</strong>.</span
    >
    <p-button label="Cancelar" size="small" [text]="true" (onClick)="cancelPick()" />
  </div>
  }

  <div class="odb-layout">
    <!-- el splitter dibujado como el dispositivo -->
    <div class="odb-shell" [ngClass]="shellSize">
      @if (assigned.length) {
      <div class="odb-grid">
        @for (port of assigned; track $index) {
        <ng-container
          [ngTemplateOutlet]="portCard"
          [ngTemplateOutletContext]="{ $implicit: port }"
        />
        }
      </div>
      } @if (unassigned.length) {
      <div class="odb-unassigned" [class.alone]="!assigned.length">
        <p class="odb-unassigned-title">
          <i class="pi pi-exclamation-triangle"></i> ONUs adjuntas sin puerto asignado
        </p>
        <div class="odb-unassigned-grid">
          @for (port of unassigned; track port.id) {
          <ng-container
            [ngTemplateOutlet]="portCard"
            [ngTemplateOutletContext]="{ $implicit: port }"
          />
          }
        </div>
      </div>
      } @if (!assigned.length && !unassigned.length) {
      <p class="py-10 text-center text-gray-500">Este splitter no tiene ONUs asignadas.</p>
      }
      <span class="odb-gland" aria-hidden="true"></span>
    </div>

    <!-- puerto seleccionado -->
    <aside class="odb-panel">
      <p class="odb-panel-subtitle">Puerto seleccionado</p>
      <p class="odb-panel-title">Puerto del splitter - {{ panelTitle }}</p>

      @if (current; as c) { @if (!portNo(c) && !c.free) {
      <p class="mb-3 flex items-center gap-1.5 text-xs font-semibold text-gray-700">
        <i class="pi pi-exclamation-triangle text-gray-500"></i> Sin puerto asignado
      </p>
      } @if (c.free) {
      <div class="odb-group">
        <p class="odb-group-title">Asignar una ONU al {{ portLabel(c) }}</p>
        <input
          id="odb-search-onu"
          class="w-full rounded border border-gray-300 px-2 py-1.5 text-sm"
          placeholder="Buscar ONU por cliente, SN, nombre u OLT"
          [ngModel]="searchTerm"
          (ngModelChange)="onSearch($event)"
        />
        @if (searchTerm.trim().length < 2) {
        <p class="mt-1 text-xs text-gray-500">Escriba al menos 2 caracteres para buscar.</p>
        } @else if (searching) {
        <p class="mt-1 text-xs text-gray-500">Buscando…</p>
        } @else if (searchResults) {
        <ul class="mt-2 max-h-48 divide-y overflow-y-auto rounded border border-gray-100">
          @for (onu of searchResults; track onu.id) {
          <li>
            <button
              type="button"
              class="block w-full px-2 py-1.5 text-left text-xs hover:bg-blue-50"
              [disabled]="busy"
              (click)="attach(onu, portNo(c))"
            >
              <strong>{{ onu.location_name || onu.client_external_id || onu.sn }}</strong>
              <span class="block text-gray-500"
                >{{ onu.sn }} @if (onu.odb_name) { · {{ onu.odb_name }} }</span
              >
            </button>
          </li>
          } @empty {
          <li class="px-2 py-2 text-xs text-gray-500">No se encontraron ONUs</li>
          }
        </ul>
        <p class="mt-1 text-[11px] text-gray-400">
          Si elige una ONU de otro splitter, se mueve a este puerto.
        </p>
        }
      </div>
      } @else {
      <div class="odb-group">
        <p class="odb-group-title">Puerto del splitter</p>
        <div class="odb-actions">
          @if (freePorts) {
          <p-button
            [label]="portNo(c) ? 'Cambiar de puerto' : 'Asignar puerto'"
            icon="pi pi-arrow-right-arrow-left"
            size="small"
            severity="secondary"
            [outlined]="true"
            (onClick)="startPick(c)"
          />
          } @else if (!portNo(c)) {
          <span class="text-xs text-gray-400">Sin puertos vacíos</span>
          }
          <p-button
            label="Quitar"
            icon="pi pi-minus-circle"
            size="small"
            severity="secondary"
            [outlined]="true"
            [loading]="busy"
            (onClick)="unassign(c)"
          />
        </div>
      </div>

      <div class="odb-group">
        <p class="odb-group-title">ONU</p>
        <div class="odb-actions">
          <p-button
            label="Ver detalle de la ONU"
            icon="pi pi-external-link"
            size="small"
            severity="secondary"
            [outlined]="true"
            (onClick)="openOnu.emit(c.id!)"
          />
          <p-button
            label="Actualizar"
            icon="pi pi-refresh"
            size="small"
            severity="secondary"
            [outlined]="true"
            [loading]="refreshing"
            (onClick)="refresh()"
          />
        </div>
      </div>

      <div class="odb-group">
        <p class="odb-group-title">Mapa</p>
        @if (hasMap(c)) {
        <a
          class="text-xs font-semibold text-blue-700 hover:underline"
          [href]="mapUrl(c)"
          target="_blank"
          rel="noopener"
          ><i class="pi pi-map-marker text-xs"></i> Ver en el mapa</a
        >
        } @else {
        <p class="text-xs text-gray-400">La ONU no tiene ubicación en el mapa</p>
        }
      </div>

      <dl class="odb-rows">
        <div>
          <dt>Estado</dt>
          <dd [style.color]="statusMeta(c).color">{{ c.status || '–' }}</dd>
        </div>
        <div>
          <dt>ONU SN / MAC</dt>
          <dd>
            <button
              type="button"
              class="font-semibold text-blue-700 hover:underline"
              (click)="openOnu.emit(c.id!)"
            >
              {{ c.sn || c.client_external_id || '–' }}
            </button>
          </dd>
        </div>
        <div>
          <dt>Nombre</dt>
          <dd>{{ c.name || '–' }}</dd>
        </div>
        <div>
          <dt>Dirección</dt>
          <dd>{{ c.address || '-' }}</dd>
        </div>
        <div>
          <dt>Zona</dt>
          <dd>{{ c.zone_name || '–' }}</dd>
        </div>
        <div>
          <dt>Rx OLT</dt>
          <dd class="flex items-center justify-end gap-1.5">
            {{ rx(c, 'rx1310') }}
            <span class="odb-bars" [title]="signalMeta(c).label">
              @for (b of [1, 2, 3, 4]; track b) {
              <span
                [style.height.px]="2 + b * 2"
                [style.background]="b <= bars(c) ? signalMeta(c).color : '#cbd5e1'"
              ></span>
              }
            </span>
          </dd>
        </div>
        <div>
          <dt>Rx ONU</dt>
          <dd>{{ rx(c, 'rx1490') }}</dd>
        </div>
        <div>
          <dt>Distancia</dt>
          <dd>{{ distance(c) }}</dd>
        </div>
        <div>
          <dt>OLT</dt>
          <dd>{{ c.olt_name || '–' }}</dd>
        </div>
        <div>
          <dt>PON</dt>
          <dd class="text-blue-700">{{ c.pon || '–' }}</dd>
        </div>
        <div>
          <dt>Último cambio</dt>
          <dd class="text-blue-700">{{ c.last_status_change || '–' }}</dd>
        </div>
      </dl>
      } } @else {
      <p class="text-sm text-gray-500">Seleccione un puerto o una ONU del splitter.</p>
      }
    </aside>
  </div>

  <!-- pie: anillos de uso, estado y señal -->
  @if (usage; as u) {
  <div class="odb-footer">
    <ng-container [ngTemplateOutlet]="usageBlock" [ngTemplateOutletContext]="{ $implicit: u }" />
    <div class="odb-footer-actions">
      <p-button
        label="Actualizar"
        icon="pi pi-refresh"
        size="small"
        severity="secondary"
        [outlined]="true"
        [loading]="refreshingAll"
        title="Relee la señal de las ONUs desde la OLT"
        (onClick)="refreshAll()"
      />
      <p-button
        label="Cerrar"
        size="small"
        severity="secondary"
        [outlined]="true"
        (onClick)="closed.emit()"
      />
    </div>
  </div>
  }
</div>
} }
